import { ToastContainer } from 'react-toastify';
import Router from './router/Router'
import 'react-toastify/dist/ReactToastify.css';
import ChatBott from './ChatBott';

function App() {
    return (
        <>
            <Router/>
            <ChatBott/>
 <ToastContainer position="top-center" autoClose={4000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover draggable theme="dark" />
 
 
       </>
    );
}

export default App
